import { styled } from "@glitz/react";
import { useNavigate } from "react-router-dom";
import {
  FaSwimmer,
  FaBiking,
  FaRunning,
  FaBoxOpen,
  FaCalculator,
} from "react-icons/fa";
import { spacing, fontSize, fontWeight, white, black, green } from "../theme";
import navConfig from "../nav.config";

const categoryIcons = (icon?: string) => {
  switch (icon) {
    case "bike":
      return <FaBiking />;
    case "swim":
      return <FaSwimmer />;
    case "run":
      return <FaRunning />;
    case "calculator":
      return <FaCalculator />;
    case "package":
      return <FaBoxOpen />;
    default:
      return null;
  }
};

const Categories = () => {
  const navigate = useNavigate();
  const { categories, tools } = navConfig;

  return (
    <Wrapper>
      {categories.map((category) => (
        <CategoryItem
          onClick={() => navigate(`/kategorier/${category.slug}`)}
          key={category.slug}
        >
          {categoryIcons(category.icon)} {category.label}
        </CategoryItem>
      ))}
      {tools.map((tool) => (
        <CategoryItem
          onClick={() => navigate(tool.path)}
          key={tool.path}
        >
          {categoryIcons(tool.icon)} {tool.label}
        </CategoryItem>
      ))}
    </Wrapper>
  );
};

const CategoryItem = styled.div({
  borderBottom: { style: "solid", color: black, width: "6px" },
  padding: { x: spacing.s, y: spacing.s },
  backgroundColor: "transparent",
  color: white,
  fontSize: fontSize.m,
  fontWeight: fontWeight.bold,
  cursor: "pointer",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: spacing.xs,
  ":hover": {
    borderBottom: { style: "solid", color: green, width: "6px" },
  },
});

const Wrapper = styled.nav({
  width: "100%",
  backgroundColor: black,
  display: "flex",
  gap: spacing.s,
  padding: { x: spacing.s },
  zIndex: 1000,
});

export default Categories;
